<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>{{ program.rules ? 'RULES / ' : '' }}TERMS &amp; CONDITIONS</h1>
    </div>

    <div class="container">
      <br>
      <div v-if="!!program.rules">
        <h2>Rules</h2>
        <div class="row text-container">
          <div v-html="program.rules">
          </div>
        </div>
        <br><br>
      </div>
      <div v-if="!!program.terms">
        <h2>Terms &amp; Conditions</h2>
        <div class="row text-container">
          <div v-html="program.terms"></div>
        </div><br>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RulesAndTerms',
  mounted () {
    // this.getLoyaltyProgramBySlug(this.$store.state.slug)
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ])
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ])
  }
}
</script>

<style scoped>
h2 {
  color: #2a2a2a;
}
.text-container {
  border: 2px solid #efefef;
  border-radius: 5px;
  padding: 5px;
  height: 250px;
  overflow-y: auto;
}
</style>
